import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@vueuse/head'
import router from '@/helpers/router'
import App from './App.vue'
import { getConfig } from '../config.js'
import vuetify, { applyAccessibilityPreferences } from '@/plugins/vuetify'
import './assets/styles/main.scss'
import './assets/styles/accessibility.scss'

const app = createApp(App)
const head = createHead()

const domain = process.env.VUE_APP_DOMAIN
const config = getConfig(domain)
app.config.globalProperties.$config = config

app.use(router)
app.use(head)
app.use(createPinia())
app.use(vuetify)

// Apply user accessibility preferences
applyAccessibilityPreferences(vuetify)

app.provide('config', config)
app.mount('#app')

